import React from 'react';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from './ui/dialog';

export default function PublishingDialog({ open, status, onClose }) {
    // status can be: 'uploading', 'success', 'error'

    const getIcon = () => {
        switch (status) {
            case 'uploading':
                return <Loader2 className="h-16 w-16 animate-spin text-primary" />;
            case 'success':
                return <CheckCircle2 className="h-16 w-16 text-green-500" />;
            case 'error':
                return <XCircle className="h-16 w-16 text-destructive" />;
            default:
                return null;
        }
    };

    const getTitle = () => {
        switch (status) {
            case 'uploading':
                return 'Publishing Your Flow...';
            case 'success':
                return 'Published Successfully!';
            case 'error':
                return 'Publishing Failed';
            default:
                return '';
        }
    };

    const getDescription = () => {
        switch (status) {
            case 'uploading':
                return 'Please wait while we generate and upload your onboarding flow. This may take a few moments.';
            case 'success':
                return 'Your onboarding flow has been published and is now live! Note: Due to caching, updates may take up to 1 minute to appear.';
            case 'error':
                return 'There was an error publishing your flow. Please try again.';
            default:
                return '';
        }
    };

    return (
        <Dialog open={open} onOpenChange={status !== 'uploading' ? onClose : undefined}>
            <DialogContent className="sm:max-w-md" hideClose={status === 'uploading'}>
                <DialogHeader>
                    <div className="flex flex-col items-center justify-center py-6">
                        {getIcon()}
                        <DialogTitle className="mt-4 text-center text-xl">
                            {getTitle()}
                        </DialogTitle>
                        <DialogDescription className="mt-2 text-center">
                            {getDescription()}
                        </DialogDescription>
                    </div>
                </DialogHeader>

                {status === 'uploading' && (
                    <div className="space-y-2">
                        <div className="flex items-center gap-2 text-sm text-muted-foreground">
                            <div className="h-2 w-2 rounded-full bg-primary animate-pulse" />
                            Generating HTML...
                        </div>
                        <div className="flex items-center gap-2 text-sm text-muted-foreground">
                            <div className="h-2 w-2 rounded-full bg-primary animate-pulse animation-delay-200" />
                            Uploading to storage...
                        </div>
                        <div className="flex items-center gap-2 text-sm text-muted-foreground">
                            <div className="h-2 w-2 rounded-full bg-primary animate-pulse animation-delay-400" />
                            Finalizing...
                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}
